import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Tea.css";

export default function Cart() {
    const navigate = useNavigate();

    const [cartItems, setCartItems] = useState(() => {
        try {
            const savedCart = localStorage.getItem("cart");
            return savedCart ? JSON.parse(savedCart) : [];
        } catch (error) {
            return [];
        }
    });

    useEffect(() => {
        localStorage.setItem("cart", JSON.stringify(cartItems));
    }, [cartItems]);

    const increaseQty = (index) => {
        setCartItems((currentItems) =>
            currentItems.map((item, itemIndex) =>
                itemIndex === index
                    ? {
                          ...item,
                          qty: Number(item.qty || 1) + 1
                      }
                    : item
            )
        );
    };

    const decreaseQty = (index) => {
        setCartItems((currentItems) =>
            currentItems
                .map((item, itemIndex) =>
                    itemIndex === index
                        ? {
                              ...item,
                              qty: Math.max(
                                  Number(item.qty || 1) - 1,
                                  0
                              )
                          }
                        : item
                )
                .filter((item) => Number(item.qty || 1) > 0)
        );
    };

    const removeItem = (index) => {
        setCartItems((currentItems) =>
            currentItems.filter(
                (_, itemIndex) => itemIndex !== index
            )
        );
    };

    const clearCart = () => {
        setCartItems([]);
        localStorage.removeItem("cart");
    };

    const grandTotal = cartItems.reduce(
        (total, item) =>
            total +
            Number(item.price || 0) *
                Number(item.qty || 1),
        0
    );

    const totalItems = cartItems.reduce(
        (total, item) =>
            total + Number(item.qty || 1),
        0
    );

    if (cartItems.length === 0) {
        return (
            <div className="cart-page">
                <div className="empty-cart">
                    <div className="empty-cart-icon">
                        🛒
                    </div>

                    <span className="cart-eyebrow">
                        YOUR SHOPPING BAG
                    </span>

                    <h2>
                        Your Cart Is Empty
                    </h2>

                    <p>
                        Looks like you haven't added
                        anything to your cart yet.
                    </p>

                    <button
                        className="back-shopping"
                        onClick={() =>
                            navigate("/product")
                        }
                    >
                        Continue Shopping
                        <span>→</span>
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="cart-page">

            <div className="cart-header">

                <div>
                    <span className="cart-eyebrow">
                        SHOPPING BAG
                    </span>

                    <h1 className="cart-title">
                        Your Cart
                    </h1>

                    <p className="cart-count">
                        {totalItems} item
                        {totalItems !== 1 ? "s" : ""} in
                        your cart
                    </p>
                </div>

                <button
                    className="clear-cart-btn"
                    onClick={clearCart}
                >
                    Clear Cart
                </button>

            </div>

            <div className="cart-layout">

                <div className="cart-container">

                    {cartItems.map((item, index) => (

                        <div
                            className="cart-card"
                            key={`${item.id}-${index}`}
                        >

                            <div className="cart-image-wrap">

                                <img
                                    src={item.image}
                                    alt={item.name}
                                    className="cart-img"
                                />

                            </div>

                            <div className="cart-info">

                                <span className="cart-product-category">
                                    {item.category ||
                                        "Premium Selection"}
                                </span>

                                <h3>
                                    {item.name}
                                </h3>

                                <p className="cart-price">
                                    ₹{Number(item.price || 0)}
                                </p>

                                <div className="cart-actions">

                                    <div className="qty-box">

                                        <button
                                            type="button"
                                            className="qty-btn"
                                            onClick={() =>
                                                decreaseQty(
                                                    index
                                                )
                                            }
                                        >
                                            −
                                        </button>

                                        <span className="qty">
                                            {item.qty || 1}
                                        </span>

                                        <button
                                            type="button"
                                            className="qty-btn"
                                            onClick={() =>
                                                increaseQty(
                                                    index
                                                )
                                            }
                                        >
                                            +
                                        </button>

                                    </div>

                                    <button
                                        type="button"
                                        className="remove-btn"
                                        onClick={() =>
                                            removeItem(index)
                                        }
                                    >
                                        Remove
                                    </button>

                                </div>

                            </div>

                            <div className="cart-item-total">

                                <span>
                                    Item Total
                                </span>

                                <strong>
                                    ₹
                                    {Number(
                                        item.price || 0
                                    ) *
                                        Number(
                                            item.qty || 1
                                        )}
                                </strong>

                            </div>

                        </div>

                    ))}

                </div>

                <aside className="cart-summary">

                    <span className="summary-eyebrow">
                        ORDER SUMMARY
                    </span>

                    <h2>
                        Summary
                    </h2>

                    <div className="summary-row">
                        <span>
                            Products
                        </span>

                        <span>
                            {totalItems}
                        </span>
                    </div>

                    <div className="summary-row">
                        <span>
                            Subtotal
                        </span>

                        <span>
                            ₹{grandTotal}
                        </span>
                    </div>

                    <div className="summary-divider" />

                    <div className="summary-total">
                        <span>
                            Grand Total
                        </span>

                        <strong>
                            ₹{grandTotal}
                        </strong>
                    </div>

                    <button
                        type="button"
                        className="checkout-btn"
                        onClick={() =>
                            navigate("/checkout", {
                                state: {
                                    cartItems,
                                    grandTotal
                                }
                            })
                        }
                    >
                        Proceed to Checkout
                        <span>→</span>
                    </button>

                    <button
                        type="button"
                        className="back-btn"
                        onClick={() =>
                            navigate("/product")
                        }
                    >
                        ← Continue Shopping
                    </button>

                </aside>

            </div>

        </div>
    );
}